/**
 * v2 통합 리드(POST /v2/leads/)의 임박도 enum과 광고 전환용 이벤트 키 매핑.
 *
 * 견적 퍼널은 쿠키에 담긴 긴 문장을 키로 쓰는 별도 매핑
 * (`platform` 의 `장례준비긴급도_LIST_EVENT_KEY`)을 갖고 있고, 어휘가 서로 다르다.
 * 여기는 v2 리드 전용이며, 최종 이벤트 접미사(now/week/month/notyet)만 공유한다.
 *
 * `platform/apis/postLeadV2.ts` 의 `LeadUrgencyStatus` 와 같은 값 집합이다.
 * 한쪽이 바뀌면 `useSubmitLead` 호출부에서 컴파일 에러로 잡힌다.
 */
export type LeadUrgency = "여유" | "1달" | "임박" | "임종상태";

/** 임박도를 모르는 리드(폼에 임박도 문항이 없는 화면)의 이벤트 접미사. */
export const LEAD_URGENCY_UNKNOWN = "unknown";

export const LEAD_URGENCY_EVENT_KEY: Record<
  LeadUrgency,
  "notyet" | "month" | "week" | "now"
> = {
  여유: "notyet",
  "1달": "month",
  임박: "week",
  임종상태: "now",
};

/**
 * 광고 전환용 리드 이벤트 접미사. 임박도가 없으면 `unknown`.
 * 접미사를 붙여 `goi_lead_{key}` 로 발화한다.
 */
export const getLeadUrgencyEventKey = (urgency?: LeadUrgency | null) =>
  urgency ? LEAD_URGENCY_EVENT_KEY[urgency] : LEAD_URGENCY_UNKNOWN;
